const colors = {
  black: "#231F20",
  main: "#0F62FE",
  gradient: "#1175B5",
  darkBlue: "#244065",
  midGray: "#666666",
  lightGray: "#ededed",
};

export default colors;
